import { UserInputItem as UserInputItemType } from '../../../types/conversation';

interface UserInputItemProps {
  item: UserInputItemType;
}

export function UserInputItem({ item }: UserInputItemProps) {
  return (
    <div className="flex justify-end">
      <div className="max-w-[85%] rounded-2xl rounded-tr-sm px-4 py-3 bg-purple-600 text-white">
        <p className="text-sm whitespace-pre-wrap">{item.content}</p>
      </div>
    </div>
  );
}

export default UserInputItem;
